export type CharacterGender = "male" | "female";

export const allGendersOptions: string[] = ["male", "female"];

export const isCharacterGender = (value: string): value is CharacterGender => {
  return allGendersOptions.includes(value);
}